var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.paginaStatus.modal === false
        ? _c("g-breadcrumb", {
            attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
          })
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "no-backdrop-dismiss": _vm.modalEditar,
            "no-esc-dismiss": _vm.modalEditar,
            "content-css": { minWidth: "70vw" }
          },
          model: {
            value: _vm.modalEditar,
            callback: function($$v) {
              _vm.modalEditar = $$v
            },
            expression: "modalEditar"
          }
        },
        [
          _c("q-card-main", [
            _c("div", { staticClass: "row mrg-b-10" }, [
              _c(
                "span",
                {
                  staticClass:
                    "titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12"
                },
                [
                  _c("i", { staticClass: "titulo-icone fas fa-sync" }),
                  _vm._v(
                    " Atualizar requerente de acordo com o cadastro de pessoa do município\n        "
                  )
                ]
              )
            ]),
            this.indTipoPessoa !== "J"
              ? _c("div", { staticClass: "q-card gvn-cabecalho mrg-b-10" }, [
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Nome: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(this.pessoaFisica.nomPessoa) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("CPF: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.formatarDocumento(this.pessoaFisica.numCpf)
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Data de nascimento: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.formatarDiaMesAno(
                                this.pessoaFisica.datNascimento
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-2 col-md-2 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Sexo: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              this.pessoaFisica.indSexo === "M"
                                ? "Masculino"
                                : this.pessoaFisica.indSexo === "F"
                                  ? "Feminino"
                                  : this.pessoaFisica.indSexo === "I"
                                    ? "Indiferente"
                                    : ""
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Estado civil: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(this.pessoaFisica.indEstadoCivilDescricao) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Nacionalidade: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              this.pessoaFisica.nacionalidade.nomNacionalidade
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Telefone móvel: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.mascaraTelefone(
                                this.pessoaFisica.pessoa.numTelefone1
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Telefone residencial: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.mascaraTelefone(
                                this.pessoaFisica.pessoa.numTelefone2
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Telefone comercial: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.mascaraTelefone(
                                this.pessoaFisica.pessoa.numTelefone3
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                      },
                      [
                        _c("strong", [_vm._v("Email: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(this.pessoaFisica.pessoa.desEmail) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                      },
                      [
                        _c("strong", [_vm._v("Filiação principal: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(this.pessoaFisica.desFiliacaoPrimeira) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ])
              : _c("div", { staticClass: "q-card gvn-cabecalho mrg-b-10" }, [
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-9 col-md-9 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Nome: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(this.pessoaJuridica.desRazaoSocial) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-3 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("CNPJ: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.formatarDocumento(this.pessoaJuridica.numCnpj)
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Telefone móvel: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.mascaraTelefone(
                                this.pessoaJuridica.pessoa.numTelefone1
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Telefone residencial: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.mascaraTelefone(
                                this.pessoaJuridica.pessoa.numTelefone2
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "col-lg-4 col-md-4 col-sm-12 col-xs-12" },
                      [
                        _c("strong", [_vm._v("Telefone comercial: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.mascaraTelefone(
                                this.pessoaJuridica.pessoa.numTelefone3
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]),
                  _c("div", { staticClass: "row mrg-t-2" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
                      },
                      [
                        _c("strong", [_vm._v("Email: ")]),
                        _vm._v(
                          "\n            " +
                            _vm._s(this.pessoaJuridica.pessoa.desEmail) +
                            "\n          "
                        )
                      ]
                    )
                  ])
                ]),
            _c(
              "table",
              {
                staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                attrs: { cellspacing: "0", cellpadding: "0" }
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", {
                      staticClass: "text-left",
                      attrs: { width: "1%" }
                    }),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "10%" } },
                      [_vm._v("CEP")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "10%" } },
                      [_vm._v("Tipo")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "20%" } },
                      [_vm._v("Logradouro")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "10%" } },
                      [_vm._v("Número")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "10%" } },
                      [_vm._v("Complemento")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "15%" } },
                      [_vm._v("Bairro")]
                    ),
                    _c(
                      "th",
                      { staticClass: "text-left", attrs: { width: "20%" } },
                      [_vm._v("Município")]
                    )
                  ])
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.arrayEndereco, function(mov, index) {
                    return _c("tr", { key: mov.codPessoaEndereco }, [
                      _c(
                        "td",
                        { staticClass: "text-right" },
                        [
                          _c("q-option-group", {
                            attrs: {
                              color: "secondary",
                              type: "radio",
                              options: [
                                { label: "", value: mov.codPessoaEndereco }
                              ]
                            },
                            on: {
                              input: function($event) {
                                _vm.atualizarEnderecoSelecionado(index)
                              },
                              change: function($event) {
                                _vm.atualizarEnderecoSelecionado(index)
                              },
                              focus: function($event) {
                                _vm.atualizarEnderecoSelecionado(index)
                              }
                            },
                            model: {
                              value: mov.enderecoSelecionado,
                              callback: function($$v) {
                                _vm.$set(mov, "enderecoSelecionado", $$v)
                              },
                              expression: "mov.enderecoSelecionado"
                            }
                          })
                        ],
                        1
                      ),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.codCepEndFraco) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.indTipoEndereco) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.nomLogradouroEndFraco) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.numEndereco) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.desComplemento) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.nomBairro) +
                            "\n            "
                        )
                      ]),
                      _c("td", { staticClass: "text-left" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(mov.municipio.nomMunicipioUf) +
                            "\n            "
                        )
                      ])
                    ])
                  })
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "col-sm-6 text-right mrg-t-10" },
              [
                _c("q-btn", {
                  staticStyle: { "margin-right": "5px" },
                  attrs: {
                    id: "Cancelar",
                    name: "Cancelar",
                    color: "black",
                    "text-color": "white",
                    label: "Cancelar"
                  },
                  on: {
                    click: function($event) {
                      _vm.modalEditar = false
                    }
                  }
                }),
                _c("q-btn", {
                  attrs: {
                    icon: "check",
                    id: "Confirmar",
                    name: "Confirmar",
                    color: "positive",
                    label: "Confirmar"
                  },
                  on: { click: _vm.atualizarRequerente }
                })
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "no-backdrop-dismiss": _vm.modalEndereco,
            "no-esc-dismiss": _vm.modalEndereco,
            "content-css": { minWidth: "70vw" }
          },
          model: {
            value: _vm.modalEndereco,
            callback: function($$v) {
              _vm.modalEndereco = $$v
            },
            expression: "modalEndereco"
          }
        },
        [
          _c(
            "q-card-main",
            [
              _c("div", { staticClass: "row mrg-b-10" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "titulo-modal-processo col-lg-12 col-md-12 col-sm-12 col-xs-12"
                  },
                  [
                    _c("i", { staticClass: "titulo-icone fas fa-sync" }),
                    _vm._v(" Atualizar endereço requerente\n        ")
                  ]
                )
              ]),
              _c("q-search", {
                staticClass: "gvn-q-search",
                attrs: {
                  placeholder: "Pesquisar",
                  debounce: 1,
                  "max-length": 10,
                  clearable: false
                },
                on: {
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.pesquisarTermo()
                  }
                },
                model: {
                  value: _vm.termoEnderecoRequerente,
                  callback: function($$v) {
                    _vm.termoEnderecoRequerente = $$v
                  },
                  expression: "termoEnderecoRequerente"
                }
              }),
              _c(
                "q-layout",
                {
                  staticClass: "mrg-t-10",
                  staticStyle: {
                    height: "400px",
                    "max-height": "400px",
                    width: "100%"
                  },
                  attrs: { container: "" }
                },
                [
                  _c(
                    "table",
                    {
                      staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
                      attrs: { cellspacing: "0", cellpadding: "0" }
                    },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("th", {
                            staticClass: "text-left",
                            attrs: { width: "1%" }
                          }),
                          _c(
                            "th",
                            {
                              staticClass: "text-left",
                              attrs: { width: "10%" }
                            },
                            [_vm._v("CEP")]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "text-left",
                              attrs: { width: "10%" }
                            },
                            [_vm._v("Tipo")]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "text-left",
                              attrs: { width: "20%" }
                            },
                            [_vm._v("Logradouro")]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "text-left",
                              attrs: { width: "25%" }
                            },
                            [_vm._v("Bairro")]
                          ),
                          _c(
                            "th",
                            {
                              staticClass: "text-left",
                              attrs: { width: "25%" }
                            },
                            [_vm._v("Município")]
                          )
                        ])
                      ]),
                      _c(
                        "tbody",
                        _vm._l(
                          !this.termoEnderecoRequerente
                            ? _vm.arrayEndereco2
                            : _vm.arrayEndereco2.filter(function(x) {
                                return (
                                  x.logradouro
                                    .trim()
                                    .toUpperCase()
                                    .includes(
                                      this$1.termoEnderecoRequerente
                                        .trim()
                                        .toUpperCase()
                                    ) ||
                                  (x.nomBairro || x.bairro)
                                    .trim()
                                    .toUpperCase()
                                    .includes(
                                      this$1.termoEnderecoRequerente
                                        .trim()
                                        .toUpperCase()
                                    )
                                )
                              }),
                          function(mov, index) {
                            return _c("tr", { key: mov.codLocalizacao }, [
                              _c(
                                "td",
                                { staticClass: "text-right" },
                                [
                                  _c("q-option-group", {
                                    attrs: {
                                      color: "secondary",
                                      type: "radio",
                                      options: [
                                        { label: "", value: mov.codLocalizacao }
                                      ]
                                    },
                                    on: {
                                      input: function($event) {
                                        _vm.atualizarEnderecoSelecionado2(index)
                                      },
                                      change: function($event) {
                                        _vm.atualizarEnderecoSelecionado2(index)
                                      },
                                      focus: function($event) {
                                        _vm.atualizarEnderecoSelecionado2(index)
                                      }
                                    },
                                    model: {
                                      value: mov.enderecoSelecionado,
                                      callback: function($$v) {
                                        _vm.$set(
                                          mov,
                                          "enderecoSelecionado",
                                          $$v
                                        )
                                      },
                                      expression: "mov.enderecoSelecionado"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(mov.cep) +
                                    "\n              "
                                )
                              ]),
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(mov.tipoLogradouro) +
                                    "\n              "
                                )
                              ]),
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(mov.logradouro) +
                                    "\n              "
                                )
                              ]),
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(mov.nomBairro || mov.bairro) +
                                    "\n              "
                                )
                              ]),
                              _c("td", { staticClass: "text-left" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      mov.localidadeUf ||
                                        mov.localidade + " - " + mov.uf
                                    ) +
                                    "\n              "
                                )
                              ])
                            ])
                          }
                        )
                      )
                    ]
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "col-sm-6 text-right mrg-t-10" },
                [
                  _c("q-btn", {
                    staticStyle: { "margin-right": "5px" },
                    attrs: {
                      id: "Cancelar",
                      name: "Cancelar",
                      color: "black",
                      "text-color": "white",
                      label: "Cancelar"
                    },
                    on: {
                      click: function($event) {
                        _vm.limparModalEndereco()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      icon: "check",
                      id: "Confirmar",
                      name: "Confirmar",
                      color: "positive",
                      label: "Confirmar"
                    },
                    on: { click: _vm.atualizarEnderecoRequerente }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-card",
        [
          _c("q-card-main", [
            _c("div", { staticClass: "row mrg-t-0" }, [
              _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-0" }, [
                _vm._v("Dados Básicos")
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-3 col-xs-3" },
                [
                  _c("g-input", {
                    ref: "refCodRequerente",
                    attrs: {
                      id: "refCodRequerente",
                      name: "refCodRequerente",
                      validacao: "Number",
                      etiqueta: "Código",
                      foco: false,
                      desabilitar: true
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.codRequerente,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente,
                          "codRequerente",
                          $$v
                        )
                      },
                      expression: "paginaStatus.requerente.codRequerente"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-2 col-xs-2" },
                [
                  _c("g-select", {
                    ref: "refIndTipoPessoa",
                    attrs: {
                      id: "refIndTipoPessoa",
                      name: "refIndTipoPessoa",
                      etiqueta: "Tipo de pessoa",
                      validacao: "required",
                      itens: _vm.tipoPessoaArray,
                      "item-valor": "indTipoPessoa",
                      "item-etiqueta": "descricao",
                      foco: true,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.indTipoPessoa,
                      callback: function($$v) {
                        _vm.indTipoPessoa = $$v
                      },
                      expression: "indTipoPessoa"
                    }
                  })
                ],
                1
              ),
              _vm.indTipoPessoa === "J"
                ? _c(
                    "div",
                    { staticClass: "col-sm-7 col-xs-7 " },
                    [
                      _c("g-input", {
                        ref: "refTxtDocumento",
                        attrs: {
                          id: "refTxtDocumento",
                          name: "refTxtDocumento",
                          mascara: "cnpj",
                          validacao: "required | text | cnpj",
                          etiqueta: "CNPJ",
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao,
                          "converter-para-maiusculo": true
                        },
                        model: {
                          value: _vm.numCnpj,
                          callback: function($$v) {
                            _vm.numCnpj = $$v
                          },
                          expression: "numCnpj"
                        }
                      })
                    ],
                    1
                  )
                : _vm.indTipoPessoa === "F"
                  ? _c(
                      "div",
                      { staticClass: "col-sm-6 col-xs-6 " },
                      [
                        _c("g-input", {
                          ref: "refTxtDocumento",
                          attrs: {
                            id: "refTxtDocumento",
                            name: "refTxtDocumento",
                            mascara: "cpf",
                            validacao: "required | text | cpf",
                            etiqueta: "CPF",
                            foco: false,
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.numCpf,
                            callback: function($$v) {
                              _vm.numCpf = $$v
                            },
                            expression: "numCpf"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
              _vm.indTipoPessoa === "F"
                ? _c(
                    "div",
                    { staticClass: "col-sm-1 col-xs-1 mrg-t-20" },
                    [
                      _c("q-btn", {
                        staticStyle: {
                          background: "#550059 !important",
                          color: "white"
                        },
                        attrs: { icon: "fa fa-search" },
                        on: { click: _vm.buscarDadosPessoaFisica }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "col-sm-2 col-xs-2 " },
                    [
                      _c("g-select", {
                        ref: "refTipoDocumento",
                        attrs: {
                          id: "refTipoDocumento",
                          name: "refTipoDocumento",
                          etiqueta: "Tipo de Documento",
                          itens: _vm.documentoArray,
                          "item-valor": "tipoDocumento",
                          "item-etiqueta": "descricao",
                          foco: false,
                          validacao: "required",
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.tipoDocumento,
                          callback: function($$v) {
                            _vm.tipoDocumento = $$v
                          },
                          expression: "tipoDocumento"
                        }
                      })
                    ],
                    1
                  ),
              _vm.tipoDocumento === "RG" && _vm.indTipoPessoa === "O"
                ? _c(
                    "div",
                    { staticClass: "col-sm-5 col-xs-5 " },
                    [
                      _c("g-input", {
                        ref: "refTxtDocumentoOutro",
                        attrs: {
                          id: "refTxtDocumentoOutro",
                          name: "refTxtDocumentoOutro",
                          tamanho: 16,
                          validacao: "required | text",
                          etiqueta: "RG",
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.numRg,
                          callback: function($$v) {
                            _vm.numRg = $$v
                          },
                          expression: "numRg"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.tipoDocumento === "NIS" && _vm.indTipoPessoa === "O"
                ? _c(
                    "div",
                    { staticClass: "col-sm-5 col-xs-5 " },
                    [
                      _c("g-input", {
                        ref: "refTxtDocumentoOutro",
                        attrs: {
                          id: "refTxtDocumentoOutro",
                          name: "refTxtDocumentoOutro",
                          tamanho: 11,
                          validacao: "required | text",
                          etiqueta: "NIS",
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.numNis,
                          callback: function($$v) {
                            _vm.numNis = $$v
                          },
                          expression: "numNis"
                        }
                      })
                    ],
                    1
                  )
                : _vm.tipoDocumento === "PAS"
                  ? _c(
                      "div",
                      { staticClass: "col-sm-5 col-xs-5 " },
                      [
                        _c("g-input", {
                          ref: "refTxtDocumentoOutro",
                          attrs: {
                            id: "refTxtDocumentoOutro",
                            name: "refTxtDocumentoOutro",
                            tamanho: 10,
                            validacao: "required | text",
                            etiqueta: "PASSAPORTE",
                            foco: false,
                            desabilitar: _vm.paginaStatus.desabilitarEdicao
                          },
                          model: {
                            value: _vm.desPassaporte,
                            callback: function($$v) {
                              _vm.desPassaporte = $$v
                            },
                            expression: "desPassaporte"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
            ]),
            _c("div", { staticClass: "row" }, [
              _vm.indTipoPessoa !== "J"
                ? _c(
                    "div",
                    { staticClass: "col-sm-6 col-xs-6" },
                    [
                      _c("g-input", {
                        ref: "refNomRequerente",
                        attrs: {
                          id: "refNomRequerente",
                          name: "refNomRequerente",
                          tamanho: 100,
                          validacao: "required | text",
                          etiqueta: "Nome",
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.paginaStatus.requerente.nomRequerente,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.paginaStatus.requerente,
                              "nomRequerente",
                              $$v
                            )
                          },
                          expression: "paginaStatus.requerente.nomRequerente"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "col-sm-11 col-xs-11 " },
                    [
                      _c("g-input", {
                        ref: "refRazaoSocialInput",
                        attrs: {
                          id: "refRazaoSocialInput",
                          name: "refRazaoSocialInput",
                          validacao: "required | text",
                          etiqueta: "Razão Social",
                          tamanho: 100,
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.paginaStatus.requerente.nomRequerente,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.paginaStatus.requerente,
                              "nomRequerente",
                              $$v
                            )
                          },
                          expression: "paginaStatus.requerente.nomRequerente"
                        }
                      })
                    ],
                    1
                  ),
              _vm.operacao === "Editar Requerente"
                ? _c("div", { staticClass: "col-sm-1 col-xs-1" }, [
                    _vm.paginaStatus.operacao.descricao === "Editar Requerente"
                      ? _c(
                          "div",
                          [
                            _c("q-tooltip", [
                              _vm._v(
                                "Atualizar requerente de acordo com o cadastro de pessoa do município."
                              )
                            ]),
                            _c(
                              "button",
                              {
                                staticClass: "btn-sync",
                                staticStyle: {
                                  "margin-top": "15px",
                                  "margin-left": "5px"
                                },
                                attrs: { id: "btnPessoa", name: "btnPessoa" },
                                on: { click: _vm.buscarPessoa }
                              },
                              [_c("i", { staticClass: "fa fa-sync-alt fa-lg" })]
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm.indTipoPessoa !== "J"
                ? _c(
                    "div",
                    { staticClass: "col-sm-5 col-xs-5" },
                    [
                      _c("g-input", {
                        ref: "refFiliacaoPrincipal",
                        attrs: {
                          id: "refFiliacaoPrincipal",
                          name: "refFiliacaoPrincipal",
                          validacao: "text",
                          tamanho: 200,
                          etiqueta: "Filiação Principal",
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value:
                            _vm.paginaStatus.requerente.desFiliacaoPrimeira,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.paginaStatus.requerente,
                              "desFiliacaoPrimeira",
                              $$v
                            )
                          },
                          expression:
                            "paginaStatus.requerente.desFiliacaoPrimeira"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "row" }, [
              _vm.indTipoPessoa !== "J"
                ? _c(
                    "div",
                    {
                      staticClass: "col-sm-2 col-xs-2",
                      staticStyle: { "padding-top": "10px" }
                    },
                    [
                      _c("g-dateInput", {
                        ref: "refDataNascimentoRequerente",
                        attrs: {
                          id: "refDataNascimentoRequerente",
                          name: "refDataNascimentoRequerente",
                          etiqueta: "Data de Nascimento",
                          desabilitar: _vm.paginaStatus.desabilitarEdicao,
                          somenteLeitura: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.dataNascimento,
                          callback: function($$v) {
                            _vm.dataNascimento = $$v
                          },
                          expression: "dataNascimento"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.indTipoPessoa !== "J"
                ? _c(
                    "div",
                    {
                      staticClass: "col-sm-2 col-xs-2",
                      staticStyle: { "padding-top": "10px" }
                    },
                    [
                      _c("g-select", {
                        ref: "refIndSexo",
                        attrs: {
                          id: "refIndSexo",
                          name: "refIndSexo",
                          etiqueta: "Sexo",
                          itens: _vm.sexoArray,
                          "item-valor": "indSexo",
                          "item-etiqueta": "descricao",
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.indSexo,
                          callback: function($$v) {
                            _vm.indSexo = $$v
                          },
                          expression: "indSexo"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.indTipoPessoa !== "J"
                ? _c(
                    "div",
                    {
                      staticClass: "col-sm-2 col-xs-2",
                      staticStyle: { "padding-top": "10px" }
                    },
                    [
                      _c("g-select", {
                        ref: "refIndEstadoCivil",
                        attrs: {
                          id: "refIndEstadoCivil",
                          name: "refIndEstadoCivil",
                          etiqueta: "Estado Civil",
                          itens: _vm.estadoCivilArray,
                          "item-valor": "indEstadoCivil",
                          "item-etiqueta": "descricao",
                          foco: false,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.indEstadoCivil,
                          callback: function($$v) {
                            _vm.indEstadoCivil = $$v
                          },
                          expression: "indEstadoCivil"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.indTipoPessoa !== "J"
                ? _c(
                    "div",
                    {
                      staticClass: "col-sm-3 col-xs-3",
                      staticStyle: { "padding-top": "10px" }
                    },
                    [
                      _c("g-autocomplete", {
                        ref: "refNacionalidade",
                        attrs: {
                          id: "refNacionalidade",
                          name: "refNacionalidade",
                          etiqueta: "Nacionalidade",
                          valor: "codNacionalidade",
                          foco: false,
                          validacao: "required | text",
                          descricaoPrimaria: "nomNacionalidade",
                          api: _vm.apiNacionalidade,
                          desabilitar: _vm.paginaStatus.desabilitarEdicao
                        },
                        model: {
                          value: _vm.codNacionalidade,
                          callback: function($$v) {
                            _vm.codNacionalidade = $$v
                          },
                          expression: "codNacionalidade"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "col-sm-3 col-xs-3",
                  staticStyle: { "padding-top": "10px" }
                },
                [
                  _c("g-select", {
                    ref: "refIndSituacaoCadastral",
                    attrs: {
                      id: "refIndSituacaoCadastral",
                      name: "refIndSituacaoCadastral",
                      etiqueta: "Situação Cadastral",
                      validacao: "required",
                      itens: _vm.situacaoCadastralArray,
                      "item-valor": "indSituacaoCadastral",
                      "item-etiqueta": "descricao",
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.indSituacaoCadastral,
                      callback: function($$v) {
                        _vm.indSituacaoCadastral = $$v
                      },
                      expression: "indSituacaoCadastral"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-10" }, [
                _vm._v("Contato")
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-2 col-xs-2 " },
                [
                  _c("g-input", {
                    ref: "refNumTelefoneMovel",
                    attrs: {
                      id: "refNumTelefoneMovel",
                      name: "refNumTelefoneMovel",
                      validacao: "Number | telefone",
                      etiqueta: "Telefone Móvel",
                      mascara: "telefone",
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.numTelefoneMovel,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente,
                          "numTelefoneMovel",
                          $$v
                        )
                      },
                      expression: "paginaStatus.requerente.numTelefoneMovel"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-2 col-xs-2 " },
                [
                  _c("g-input", {
                    ref: "refNumTelefoneResidencial",
                    attrs: {
                      id: "refNumTelefoneResidencial",
                      name: "refNumTelefoneResidencial",
                      validacao: "text | telefone",
                      etiqueta: "Telefone Residencial",
                      mascara: "telefone",
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.numTelefoneResidencial,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente,
                          "numTelefoneResidencial",
                          $$v
                        )
                      },
                      expression:
                        "paginaStatus.requerente.numTelefoneResidencial"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-2 col-xs-2 " },
                [
                  _c("g-input", {
                    ref: "refNumTelefoneComercial",
                    attrs: {
                      id: "refNumTelefoneComercial",
                      name: "refNumTelefoneComercial",
                      validacao: "text | telefone",
                      etiqueta: "Telefone Comercial",
                      mascara: "telefone",
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.numTelefoneComercial,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente,
                          "numTelefoneComercial",
                          $$v
                        )
                      },
                      expression: "paginaStatus.requerente.numTelefoneComercial"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xs-6" },
                [
                  _c("g-input", {
                    ref: "refTxtEmail",
                    attrs: {
                      id: "refTxtEmail",
                      name: "refTxtEmail",
                      tipo: "text",
                      etiqueta: "E-mail",
                      validacao: "email",
                      tamanho: 100,
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.txtEmail,
                      callback: function($$v) {
                        _vm.$set(_vm.paginaStatus.requerente, "txtEmail", $$v)
                      },
                      expression: "paginaStatus.requerente.txtEmail"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 gvn-title-primary mrg-t-10" }, [
                _vm._v("Endereço")
              ])
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-4 col-xs-4" },
                [
                  _c("g-input", {
                    ref: "refNumCep",
                    attrs: {
                      id: "refNumCep",
                      name: "refNumCep",
                      validacao: "required | text | cep",
                      mascara: "cep",
                      etiqueta: "CEP",
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.numCEP,
                      callback: function($$v) {
                        _vm.numCEP = $$v
                      },
                      expression: "numCEP"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-4" },
                [
                  _c(
                    "div",
                    { staticClass: "mrg-t-20 mrg-l-10" },
                    [
                      _c(
                        "q-icon",
                        {
                          staticClass: "mrg-t-20",
                          attrs: {
                            color: "blue-grey-9",
                            size: "1rem",
                            name: "fas fa-question-circle"
                          },
                          on: {
                            click: function($event) {
                              _vm.chamarPaginaCep()
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticStyle: {
                                "text-decoration": "none",
                                color: "#37474F",
                                "margin-left": "10px"
                              },
                              attrs: {
                                href:
                                  "http://www.buscacep.correios.com.br/sistemas/buscacep/",
                                target: "_blank"
                              }
                            },
                            [
                              _vm._v("Não sei meu CEP\n                "),
                              _c("q-tooltip", [
                                _vm._v(
                                  "Clique aqui para buscar o CEP nos correios."
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      ),
                      _c("div")
                    ],
                    1
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-sm-6 col-xs-6",
                  staticStyle: { "padding-right": "10px" }
                },
                [
                  _c("g-autocomplete", {
                    ref: "refLogradouro",
                    attrs: {
                      id: "refLogradouro",
                      name: "refLogradouro",
                      etiqueta: "Logradouro",
                      valor: "codLogradouro",
                      foco: false,
                      validacao: "required | text",
                      descricaoPrimaria: "nomLogradouro",
                      tamanho: 100,
                      api: _vm.apiLogradouro,
                      desabilitar: _vm.desabilitarLogradouro,
                      permitirTextoLivre: "true",
                      filtroAdicional: _vm.filtroLogradouro
                    },
                    model: {
                      value:
                        _vm.paginaStatus.requerente.logradouro.codLogradouro,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente.logradouro,
                          "codLogradouro",
                          $$v
                        )
                      },
                      expression:
                        "paginaStatus.requerente.logradouro.codLogradouro"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xs-6" },
                [
                  _c("g-input", {
                    ref: "refNumero",
                    attrs: {
                      id: "refNumero",
                      name: "refNumero",
                      validacao: "Number",
                      etiqueta: "Número",
                      foco: false,
                      tamanho: 5,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao,
                      permitirTextoLivre: "true"
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.numNumero,
                      callback: function($$v) {
                        _vm.$set(_vm.paginaStatus.requerente, "numNumero", $$v)
                      },
                      expression: "paginaStatus.requerente.numNumero"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-sm-6 col-xs-6",
                  staticStyle: { "padding-right": "10px" }
                },
                [
                  _c("g-autocomplete", {
                    ref: "refBairro",
                    attrs: {
                      id: "refBairro",
                      name: "refBairro",
                      etiqueta: "Bairro",
                      valor: "codBairro",
                      foco: false,
                      validacao: "required | text",
                      descricaoPrimaria: "nomBairro",
                      tamanho: 100,
                      api: _vm.apiBairro,
                      desabilitar: _vm.desabilitarBairro,
                      permitirTextoLivre: "true",
                      filtroAdicional: _vm.filtroLogradouro
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.bairro.codBairro,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente.bairro,
                          "codBairro",
                          $$v
                        )
                      },
                      expression: "paginaStatus.requerente.bairro.codBairro"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-6 col-xs-6" },
                [
                  _c("g-input", {
                    ref: "refComplemento",
                    attrs: {
                      id: "refComplemento",
                      name: "refComplemento",
                      validacao: "text",
                      etiqueta: "Complemento",
                      foco: false,
                      tamanho: 100,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.txtComplemento,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente,
                          "txtComplemento",
                          $$v
                        )
                      },
                      expression: "paginaStatus.requerente.txtComplemento"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "col-sm-8 col-xs-8",
                  staticStyle: { "padding-right": "10px" }
                },
                [
                  _c("g-autocomplete", {
                    ref: "refCidade",
                    attrs: {
                      id: "refCidade",
                      name: "refCidade",
                      etiqueta: "Cidade",
                      valor: "codMunicipio",
                      foco: false,
                      tamanho: 100,
                      validacao: "required | text",
                      descricaoPrimaria: "nomMunicipio",
                      api: _vm.apiCidade,
                      desabilitar: _vm.desabilitarCidade,
                      permitirTextoLivre: "true"
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.municipio.codMunicipio,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.requerente.municipio,
                          "codMunicipio",
                          $$v
                        )
                      },
                      expression:
                        "paginaStatus.requerente.municipio.codMunicipio"
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-4 col-xs-4" },
                [
                  _c("g-select", {
                    ref: "refUf",
                    attrs: {
                      id: "refUf",
                      name: "refUf",
                      etiqueta: "UF",
                      validacao: "required",
                      itens: _vm.ufArray,
                      "item-valor": "codigo",
                      "item-etiqueta": "descricao",
                      foco: false,
                      desabilitar: _vm.desabilitarUf
                    },
                    model: {
                      value: _vm.paginaStatus.requerente.uf.codUf,
                      callback: function($$v) {
                        _vm.$set(_vm.paginaStatus.requerente.uf, "codUf", $$v)
                      },
                      expression: "paginaStatus.requerente.uf.codUf"
                    }
                  })
                ],
                1
              )
            ])
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.paginaStatus.desabilitarEdicao,
                  expression: "!paginaStatus.desabilitarEdicao"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                id: "btnSalvar",
                name: "btnSalvar",
                color: "positive",
                icon: "check",
                size: "lg",
                round: ""
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }